import { useSelector } from 'react-redux';

const useAlgoliaLocale = () =>
  useSelector(state => state.main.language) || 'en-US';

export default useAlgoliaLocale;
